import styled from 'styled-components';

import { MEDIA_QUERIES } from "@constants";

export const ClassesPageRegisterModalDIV = styled.div`
  overflow: auto;

  .close-button {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;

    .Icon {
      width: 14px;
      height: 14px;
      background: var(--color--charcoal-600);
    }

    &:hover .Icon {
      background: var(--color--charcoal-600);
    }
  }
`;

export const ClassesPageRegisterModalContentDIV = styled.div`
  position: relative;
  margin-bottom: 15px;

  p {
    color: var(--color--charcoal-700);

    span {
      display: none;
    }
  }

  .gatsby-image-wrapper {
    display: none !important;
    position: absolute !important;
    top: 0;
    right: 0;
  }

  ${MEDIA_QUERIES.M} {
    min-width: 500px;
    margin-bottom: 30px;

    p span {
      display: inline;
    }

    .gatsby-image-wrapper {
      display: block !important;
    }
  }
`;
